import React from 'react';
import { Translation } from 'react-i18next';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Logger from '../../../../../lib/Logger';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const InviteButtonCareGuideHelpers = ({
  canInvite,
  isLoading,
  showForm,
  text = null,
  style = null,
  mock = false,
  trackerDashboardEvent,
  ...props
}) => {
  const onClick = () => {
    if (mock) {
      return;
    }
    trackerDashboardEvent(
      mixpanelEventsEnum.DASHBOARD.CARE_GUIDE_INVITATION_INVITE
    );
    showForm();
  };

  return (
    <Translation>
      {(t) => (
        <>
          <Button
            type='primary'
            icon={<PlusOutlined />}
            disabled={!canInvite}
            onClick={(e) => (mock ? null : onClick())}
          >
            {t('dashboard_admin_care_members_btn_invite')}
          </Button>
        </>
      )}
    </Translation>
  );
};

export default InviteButtonCareGuideHelpers;

Logger.log('silly', `InviteButtonCareGuideHelpers loaded.`);
